<template>
  <div class="stats" ref="container"></div>
</template>

<script>
import Stats from 'three/examples/js/libs/stats.min'
import RAF from '@/utils/RAF'

export default {
  name: 'Stats',

  data: function () {
    return {
      stats: new Stats()
    }
  },

  mounted: function () {
    this.$refs.container.appendChild(this.stats.domElement)
    RAF.add(this.onUpdate)
  },

  beforeDestroy: function () {
    RAF.remove(this.render)
  },
  methods: {
    onUpdate: function () {
      this.stats.end()
      this.stats.begin()
    }
  }
}
</script>

<style scoped lang="scss">
@import 'variables';


.stats {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
}

</style>



// WEBPACK FOOTER //
// src/atoms/Stats.vue